import '../../scss/home.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
import jQuery from 'jquery';
window.jQuery = jQuery;

// Init Swiper
var swiper = new Swiper('#top-vis .slide-content', { // eslint-disable-line no-unused-vars
  autoplay: {
    delay: 5000
  },
  pagination: {
    el: '#top-vis .slide-pager',
    clickable: true
  },
  loop: true,
  debugger: true,
  preloadImages: false,
  lazy: true
});

var hairstyle_slide = new Swiper('#hairstyle .slide-content', { // eslint-disable-line no-unused-vars, camelcase
  navigation: {
    nextEl: '#hairstyle .slide-next',
    prevEl: '#hairstyle .slide-prev'
  },
  pagination: {
    el: '#hairstyle .slide-pager',
    clickable: true
  },
  loop: true,
  debugger: true,
  preloadImages: false,
  lazy: true
});

var qanda_slide = new Swiper('#qanda .slide-content', { // eslint-disable-line no-unused-vars, camelcase
  navigation: {
    nextEl: '#qanda .slide-next',
    prevEl: '#qanda .slide-prev'
  },
  pagination: {
    el: '#qanda .slide-pager',
    clickable: true
  },
  loop: true,
  debugger: true,
  preloadImages: false,
  lazy: true
});

var blog_slide = new Swiper('#blog .slide-content', { // eslint-disable-line no-unused-vars, camelcase
  navigation: {
    nextEl: '#blog .slide-next',
    prevEl: '#blog .slide-prev'
  },
  pagination: {
    el: '#blog .slide-pager',
    clickable: true
  },
  loop: true,
  debugger: true,
  preloadImages: false,
  lazy: true
});



// WEBPACK FOOTER //
// ./src/js/entries/top.js